import React from 'react';
import { ConnectorStatus } from '../types';

interface SessionManagerProps {
  connectors: Array<{
    id: number;
    status: ConnectorStatus;
    currentPower: number;
    maxPower: number;
    activeSession?: {
      transactionId: string;
      idTag: string;
      startTime: Date;
      energyConsumed: number;
    };
  }>;
}

const SessionManager: React.FC<SessionManagerProps> = ({ connectors }) => {
  const activeSessions = connectors.filter(c => c.activeSession);

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">Active Sessions</h3>
      </div>
      
      <div className="px-6 py-4">
        {activeSessions.length === 0 ? (
          <div className="text-center text-gray-500 py-8">
            No active charging sessions
          </div>
        ) : (
          <div className="space-y-4">
            {activeSessions.map((connector) => (
              <div key={connector.id} className="border border-gray-200 rounded-lg p-4">
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h4 className="text-sm font-medium text-gray-900">
                      Connector {connector.id}
                    </h4>
                    <p className="text-sm text-gray-500">
                      Transaction: {connector.activeSession!.transactionId.substring(0, 12)}...
                    </p>
                  </div>
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    Charging
                  </span>
                </div>
                
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <span className="text-gray-500">ID Tag:</span>
                    <div className="font-medium">{connector.activeSession!.idTag}</div>
                  </div>
                  <div>
                    <span className="text-gray-500">Started:</span>
                    <div className="font-medium">
                      {connector.activeSession!.startTime.toLocaleString()}
                    </div>
                  </div>
                  <div>
                    <span className="text-gray-500">Duration:</span>
                    <div className="font-medium">
                      {Math.floor((new Date().getTime() - connector.activeSession!.startTime.getTime()) / 60000)} min
                    </div>
                  </div>
                  <div>
                    <span className="text-gray-500">Power:</span>
                    <div className="font-medium">{(connector.currentPower / 1000).toFixed(1)} kW</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SessionManager;